import React, { useEffect } from "react";
import { Container, Button } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import CommissionsTab from "./CommissionsTab";
import toast from "react-hot-toast";
import ToastNotification from "components/Toast/ToastNotification";
import hotprice from "assets/icons/hot-price.svg";

const Commissions = (props) => {
  //meta title
  document.title = `${props.t("Commissions")} | ${process.env.REACT_APP_CMS_TITLE}`;

  useEffect(() => {
    let id = toast.custom(<ToastNotification variant="error" icon={hotprice} title="หมายเหตุ : การคำนวณยอดค่าคอมของราคาสินค้า" description="ระบบจะคำนวณจากยอดของราคาสินค้า by total product นำมาคิดเป็น % เช่น กรณีถ้าสินค้าลดราคา ระบบก็จะนำราคาสินค้าที่ลดราคาแล้ว มาคำนวณ % ตาม Rate ที่ได้ตั้งค่าไว้" primaryButtonText="เข้าใจแล้ว" onPrimaryClick={() => toast.dismiss(id)} onSecondaryClick={() => toast.dismiss(id)} />, { position: "top-right", duration: 8000 });
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Commissions")} breadcrumbItem={props.t("จัดการค่าคอมมิชชัน")} />
          {/* Add your commissions management content here */}
          <CommissionsTab />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Commissions);
